import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVertexModeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 5,
			r: 1.5,
			fill: "currentColor",
			stroke: "none",
			opacity: .2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 5,
			r: 1.5,
			fill: "currentColor",
			stroke: "none",
			opacity: .2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 5,
			cy: 19,
			r: 1.5,
			fill: "currentColor",
			stroke: "none",
			opacity: .2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 19,
			r: 1.5,
			fill: "currentColor",
			stroke: "none",
			opacity: .2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 5h14M5 19h14M5 5v14M19 5v14",
			opacity: .1
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 3.5,
			fill: "currentColor",
			stroke: "none"
		})
	]
});
export default SvgVertexModeIcon;
